module.exports = __webpack_public_path__ + "img/absoluteValuationData.dfe70a24.png";